import { render, staticRenderFns } from "./gymOrders.vue?vue&type=template&id=42e4dbee"
import script from "./gymOrders.vue?vue&type=script&lang=js"
export * from "./gymOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports